const tpl = (name) => `NDFL3_LIGHT_WIZARD/${name}`;

// Draft
export const CREATE_DRAFT = tpl`CREATE_DRAFT`;
export const CREATE_DRAFT_SUCCESS = tpl`CREATE_DRAFT_SUCCESS`;
export const CREATE_DRAFT_FAILURE = tpl`CREATE_DRAFT_FAILURE`;

export const SET_DRAFT = tpl`SET_DRAFT`;

export const REFINE_DRAFT = tpl`REFINE_DRAFT`;
export const REFINE_DRAFT_SUCCESS = tpl`REFINE_DRAFT_SUCCESS`;
export const REFINE_DRAFT_FAILURE = tpl`REFINE_DRAFT_FAILURE`;

export const GET_DRAFT = tpl`GET_DRAFT`;
export const GET_DRAFT_SUCCESS = tpl`GET_DRAFT_SUCCESS`;
export const GET_DRAFT_FAILURE = tpl`GET_DRAFT_FAILURE`;

export const UPDATE_DRAFT = tpl`UPDATE_DRAFT`;
export const UPDATE_DRAFT_SUCCESS = tpl`UPDATE_DRAFT_SUCCESS`;
export const UPDATE_DRAFT_ERROR = tpl`UPDATE_DRAFT_ERROR`;

export const UPDATE_XML_DRAFT = tpl`UPDATE_XML_DRAFT`;
export const UPDATE_XML_DRAFT_SUCCESS = tpl`UPDATE_XML_DRAFT_SUCCESS`;
export const UPDATE_XML_DRAFT_FAILURE = tpl`UPDATE_XML_DRAFT_FAILURE`;

// Common actions
export const RESET_STATE = tpl`RESET_STATE`;

export const INITIALIZE = tpl`INITIALIZE`;
export const INITIALIZE_SUCCESS = tpl`INITIALIZE_SUCCESS`;
export const INITIALIZE_FAILURE = tpl`INITIALIZE_FAILURE`;

// Initial data step
export const INITIAL_DATA = tpl`INITIAL_DATA`;
export const INITIAL_DATA_SUCCESS = tpl`INITIAL_DATA_SUCCESS`;
export const INITIAL_DATA_FAILURE = tpl`INITIAL_DATA_FAILURE`;

export const SUBMIT_INITIAL_DATA = tpl`SUBMIT_INITIAL_DATA`;
export const SUBMIT_INITIAL_DATA_SUCCESS = tpl`SUBMIT_INITIAL_DATA_SUCCESS`;
export const SUBMIT_INITIAL_DATA_FAILURE = tpl`SUBMIT_INITIAL_DATA_FAILURE`;

export const GET_PARENT_DECLARATION_BY_YEAR = tpl`GET_PARENT_DECLARATION_BY_YEAR`;
export const GET_PARENT_DECLARATION_BY_YEAR_SUCCESS = tpl`GET_PARENT_DECLARATION_BY_YEAR_SUCCESS`;
export const GET_PARENT_DECLARATION_BY_YEAR_ERROR = tpl`GET_PARENT_DECLARATION_BY_YEAR_ERROR`;

// Incomes step
export const INCOMES_DATA = tpl`INCOMES_DATA`;
export const INCOMES_DATA_SUCCESS = tpl`INCOMES_DATA_SUCCESS`;
export const INCOMES_DATA_FAILURE = tpl`INCOMES_DATA_FAILURE`;

export const GET_NDFL2_BY_YEAR = tpl`GET_NDFL2_BY_YEAR`;
export const GET_NDFL2_BY_YEAR_SUCCESS = tpl`GET_NDFL2_BY_YEAR_SUCCESS`;
export const GET_NDFL2_BY_YEAR_ERROR = tpl`GET_NDFL2_BY_YEAR_ERROR`;

// Submit declaration step
export const SUBMIT_DATA = tpl`SUBMIT_DATA`;
export const SUBMIT_DATA_SUCCESS = tpl`SUBMIT_DATA_SUCCESS`;
export const SUBMIT_DATA_FAILURE = tpl`SUBMIT_DATA_FAILURE`;

export const SUBMIT_DECLARATION = tpl`SUBMIT_DECLARATION`;

export const SET_DECLARATION_SUBMITTED = tpl`SET_DECLARATION_SUBMITTED`;
export const RESET_DECLARATION_SUBMITTED = tpl`RESET_DECLARATION_SUBMITTED`;

// Get receipts pdf data
export const SET_RECEIPTS_LINK = tpl`SET_RECEIPTS_LINK`;
export const SET_RECEIPTS_LINK_SUCCESS = tpl`SET_RECEIPTS_LINK_SUCCESS`;
export const SET_RECEIPTS_LINK_FAILURE = tpl`SET_RECEIPTS_LINK_FAILURE`;

// Get saved drafts data
export const GET_SAVED_DRAFTS = tpl`GET_SAVED_DRAFTS`;
export const GET_SAVED_DRAFTS_SUCCESS = tpl`GET_SAVED_DRAFTS_SUCCESS`;
export const GET_SAVED_DRAFTS_FAILURE = tpl`GET_SAVED_DRAFTS_FAILURE`;

export const RESET_SAVED_DRAFT = tpl`RESET_SAVED_DRAFT`;

export const UPDATE_CURRENT_DRAFT = tpl`UPDATE_CURRENT_DRAFT`;

export const START_STEP_FETCHING = tpl`START_STEP_FETCHING`;
export const STOP_STEP_FETCHING = tpl`STOP_STEP_FETCHING`;

export const SAVE_DRAFT_AND_EXIT = tpl`SAVE_DRAFT_AND_EXIT`;

// Overpayments step
export const OVERPAYMENTS_DATA = tpl`OVERPAYMENTS_DATA`;
export const OVERPAYMENTS_DATA_SUCCESS = tpl`OVERPAYMENTS_DATA_SUCCESS`;
export const OVERPAYMENTS_DATA_FAILURE = tpl`OVERPAYMENTS_DATA_FAILURE`;

export const OVERPAYMENTS_SUBMIT_DATA = tpl`OVERPAYMENTS_SUBMIT_DATA`;
export const OVERPAYMENTS_SUBMIT_DATA_SUCCESS = tpl`OVERPAYMENTS_SUBMIT_DATA_SUCCESS`;
export const OVERPAYMENTS_SUBMIT_DATA_FAILURE = tpl`OVERPAYMENTS_SUBMIT_DATA_FAILURE`;
